import { render, staticRenderFns } from "./sort-icon.vue?vue&type=template&id=232db04c&"
import script from "./sort-icon.vue?vue&type=script&lang=js&"
export * from "./sort-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sort-icon.vue"
export default component.exports